import {
  Button,
  Center,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Spinner,
  Stack,
  VStack,
} from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { axiosPublic } from "../../utils/axios";
const SetPasswordPage = () => {
  window.document.title = "SOUL BLUEPRINT ALIGNMENT - Reset Password";
  const [password, setPassword] = useState("");
  const { id, token } = useParams();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationKey: ["reset_password"],
    mutationFn: () =>
      axiosPublic
        .put(
          `/api/users/update/${id}`,
          { password },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => res.data),
    onSuccess: (data: any) => {
      toast.success(data?.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      navigate("/login");
    },
    onError: (error: any) => {
      if (error) return toast.error(error?.response.data?.message);
    },
  });
  return (
    <Center w="full" h="100vh">
      <Stack
        spacing={0}
        rounded="lg"
        w="md"
        align="center"
        p={[3, 7]}
        boxShadow="lg"
      >
        <Heading pb={[4, 7]} fontSize={["18px", "22px", "28px"]}>
          Enter your new password
        </Heading>

        <VStack py={3} spacing={3} w="full">
          <FormControl isRequired>
            <FormLabel htmlFor="email">New password</FormLabel>
            <Input
              size="md"
              id="email"
              type="password"
              placeholder="Enter your new password"
              borderBottomColor="gray.200"
              variant="flushed"
              px="2"
              w="full"
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>

          <VStack w="full" spacing={0} pt={[2, 4]}>
            <Button
              onClick={() => mutation.mutate()}
              w="full"
              variant="solid"
              colorScheme="orange"
              type="submit"
              mb={2}
            >
              {mutation.isLoading ? <Spinner /> : "Change"}
            </Button>
            <Link
              to="/"
              style={{ textDecoration: "underline", color: "green" }}
            >
              Go back
            </Link>
          </VStack>
        </VStack>
      </Stack>
    </Center>
  );
};

export default SetPasswordPage;
